import { MoreHorizRounded } from "@mui/icons-material";
import { connect } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { getAnalytics, logEvent } from "firebase/analytics";
import BlurPillButton from "./BlurPillButton";
import IconSmall from "./IconSmall";
import { navigateToSigninWithRedirect } from "./signinUtils";


export const TopBar = ({
    signinClick,
    authenticated,
    hideAuthAction = false,
    horizontalInset = 20,
    fixedLogoTopLeft = false,
    logoInteractive = true,
    trailingAction,
}) => {
    const navigate = useNavigate();
    const location = useLocation();
    const analytics = getAnalytics();
    const topBarIconButtonStyle = {
        width: '34px',
        height: '34px',
        borderRadius: '50%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    };
    const profileClick = () => {
        logEvent(analytics, 'profile_click');
        navigate('/menu');
    }

    const defaultSigninClick = () => {
        navigateToSigninWithRedirect(navigate, `${location.pathname}${location.search}`);
    }

    return (
        <div className='horizontalCenter' style={{ textAlign: 'center' }}>
            <div>
                <div
                    style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: fixedLogoTopLeft ? 'flex-end' : undefined,
                    padding: `16px ${horizontalInset}px`,
                }}>
                    <div
                        className={fixedLogoTopLeft ? 'homeFixedTopLeftLogo' : undefined}
                        style={fixedLogoTopLeft ? undefined : {
                            flexGrow: 1,
                            textAlign: 'left',
                            display: 'flex',
                            alignItems: 'center',
                            minHeight: '34px',
                            transform: 'translateY(-1px)',
                        }}
                    >
                        <IconSmall interactive={logoInteractive} />
                    </div>
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end', gap: '12px', position: 'relative' }}>
                        {trailingAction}
                        {!hideAuthAction && !authenticated &&
                            <BlurPillButton onClick={signinClick ?? defaultSigninClick} label='Sign in' />
                        }
                        {!hideAuthAction && !!authenticated &&
                            <button onClick={profileClick} className='blurBackground' style={topBarIconButtonStyle}>
                                <MoreHorizRounded style={{ fontSize: '24px', color: 'var(--app-text)' }} />
                            </button>
                        }
                    </div>
                </div>
            </div>
        </div>
    );
};

const mapStateToProps = (state) => ({
    authenticated: state.user.authenticated
});

export default connect(mapStateToProps, {})(TopBar);
